/* global globalThis */
import {FACTIONS} from "../constants/factions";

/**
 * Волна 36, участок «Стройка» (C1–C5): крупные города вместо колец ферм и
 * казарм у центрального квартала. Только у ботов «золото+» (бонус «большой» и
 * выше, configs/botGoldPlus); каждая подчасть — за своим гейтом A/B
 * (isPreW36…Player в utils/bots/abTestGates). Формулы — в
 * utils/bots/evaluation/cityGrowth, применение — в decideConstructionStep.
 *
 * Откуда. Прод-реплеи 27.10 (zml5bhz, z3lg8hs, w0gn7gj, f7l8kys; разбор —
 * scratchpad волны 36): у ботов золото+ 66% своих городов к концу партии без
 * единого базового квартала (БК), у людей 46%; 0.6 БК на город против 1.0.
 * Базовый квартал ставится только смежно центральному (ЦК), а ферма и казарма —
 * смежно любому кварталу, поэтому пока БК нет, каждая ферма и казарма занимает
 * клетку кольца ЦК: после R1 у бота 0.9 свободной клетки под БК, у человека 3.
 * 80% казарм ботов поставлены в город без БК, 21% — третья и далее казарма
 * города; добор действий (полы ферма/казарма/квартал R1–10) воскрешал казармы,
 * которые основной проход обнулил (36 из 117 казарм ботов, 11 из 17 у
 * Сципиона). Новый ЦК бот ставит на минимальной дистанции к своим городам и
 * отнимает у них в среднем 0.71 легальной клетки под БК (у людей 0.20).
 */

// --- Общее: цель роста города

// Сколько базовых кварталов городу нужно в первую очередь. Легальная емкость
// кольца у города бота в R9 — 2.16 БК (проверка движком, verify/ringExact),
// у людей 1.0 БК на город при 46% городов без БК; цель 2 — «у каждого города
// 1–2 БК под храм, гильдию, лагерь или склад»
export const W36_CITY_BASE_QUARTERS_TARGET = 2;
// Тыловой хаб и кузница «сильных городов» (ось волны 33, есть только у LARGE+):
// кластеры ферм со складом и казарм с лагерем и арсеналом — на ступень больше
export const W36_HUB_BASE_QUARTERS_TARGET = 3;

// --- C1: бронь легальных клеток кольца ЦК под базовые кварталы

// Множитель оценки фермы/казармы на клетке кольца ЦК, легальной под БК, пока
// в городе меньше цели БК. Прототип на состояниях 4 реплеев (scratchpad
// construction/compareProto): 0.35 разворачивает дебют «ферма, казарма, БК»
// в «БК, БК, ферма, казарма» и не обнуляет ферму, когда других клеток нет
export const W36_RING_RESERVE_FACTOR = 0.35;

// --- C2: ценность роста города (базовый квартал как площадка спецстроения)

// База ценности БК, пока в городе меньше цели (× интенсивность бонуса). Порядок
// «ферма по нужде» (FARM_NEEDED 9 × экономика): у великого бота БК с площадкой
// под храм Вентори (~23 очка) получает 6 + 0.6 × 23 ≈ 20 и обгоняет ферму в
// кольце (≈ 11 × 0.35), у золотого (интенсивность 0.39) ≈ 8 против ≈ 4.
// В городе без свободных БК (при фермах и казарме) и с пригодной площадкой под
// спецстроение (путь влияния с клетки при influence ≥ 1.2, иначе казарма в
// городе и монеты на отряд) рост прибавляется к прежней надбавке платформы
// QUARTER_SPECIAL_PLATFORM = 4 (Цель 3 в decideConstructionStep), а не берет max
// с ней (max — только с площадками волны 33: кузница, тыловой склад). Это
// решение: обе надбавки ведут к БК в городе без БК, куда и ведет волна. Расчеты
// выше — без этих +4: при калибровке ручек __w36QuarterGrowthBase и
// __w36QuarterGrowthSpecialShare в таком городе БК ценнее на 4
export const W36_QUARTER_GROWTH_BASE = 6;
// Доля лучшего спецстроения следующего раунда в ценности БК: спецстроение
// само получит свою полную оценку, когда встанет; БК — лишь предпосылка
export const W36_QUARTER_GROWTH_SPECIAL_SHARE = 0.6;
// Цена спецстроения вычитается по курсу монет в очки (BOT_WEIGHTS.COINS_TO_POINTS)
export const W36_QUARTER_GROWTH_PRICE_FACTOR = 0.5;
// Спецстроение на новом БК встанет не раньше следующего раунда: ценность
// роста есть, пока ему остается хотя бы 2 раунда дохода (R11 при 13 раундах;
// в R12–R13 храм окупается только с путями влияния, см. lateTempleGate)
export const W36_QUARTER_GROWTH_MIN_SPECIAL_ROUNDS = 2;

// --- C3: без «мусорных» казарм

// Казарм на город: вторая — только при лагере или арсенале в городе (или при
// свежем БК рядом под лагерь), третья — только у кузницы (кап кластера
// BOT_BONUS_FORGE_BARRACKS_CAP волны 33). У людей в реплеях 3-й казармы в
// городе нет ни одной, у ботов это 21% казарм
export const W36_CITY_BARRACKS_CAP = 2;
// Инсектоиды: казармы — их экономика (рой d6 нанимается на казармах, фермы не
// нужны), дебют R1 — 3 казармы (barracksTarget); лагерь им разрешен только у
// 2+ казарм, поэтому правило «вторая — при лагере» их не касается
export const W36_INSECTOIDS_CITY_BARRACKS_CAP = 3;

// --- C4: плотность своих городов

// Штраф нового ЦК за каждый слот под БК (до цели города), который он отнимает
// у своего города правилом дальности кварталов разных городов — столько же,
// сколько стоит база роста этого слота (W36_QUARTER_GROWTH_BASE), × интенсивность
export const W36_DENSITY_LOST_SLOT_PENALTY = 6;
// Штраф нового ЦК за каждый недостающий до цели слот под БК в его собственном
// кольце (город, который не сможет вырасти): вдвое мягче — сам город с точками
// приносит доход и без БК
export const W36_DENSITY_SMALL_CITY_PENALTY = 3;

// --- C5: спецстроения по доктрине

// Экономическая доктрина (Вентори, гномы, элементали, просветленные): храм в
// нефронтирном городе — с этого раунда (раньше гейт «ранний храм» разрешал его
// только архетипу ECONOMIC_POINTS и THEOCRACY). Храм R3–R5 окупается в 2–3 раза
// при 1 очке за раунд (у Вентори — 2)
export const W36_EARLY_TEMPLE_MIN_ROUND = 3;
// Город фронтирный, если его кварталы в этой BFS-дистанции от кварталов живых
// противников — тот же порог, что у «сильных городов»
// (BOT_BONUS_FRONTIER_CITY_MAX_ENEMY_DISTANCE)
export const W36_FRONTIER_CITY_MAX_ENEMY_DISTANCE = 6;

// --- Рубильник C1 и C2 для орков и демонов

// Подчасти, которые рубильник выключает фракции (ключи записей ниже)
export const W36_FACTION_SWITCHABLE_PARTS = {
  // C1 — бронь легальных клеток кольца ЦК под базовые кварталы
  RING_RESERVE: 'ringReserve',
  // C2 — ценность роста города
  QUARTER_GROWTH: 'quarterGrowth',
};

// Действуют ли C1 и C2 у ботов золото+ орков и демонов. Сейчас — да, как у всех.
//
// Откуда. Фокус-серии noc12 (отчет 34 §8; по 12 240 партий, бот фракции против
// остальных фракций): без C1+C2 демон золото+ выигрывает на 4.0 п.п. чаще, чем
// с полной волной, орк — на 3.1 (с поправкой на поле и соперников). C1+C2 растят
// столицу в R1 и тормозят экспансию — досрочных побед на 4–5 п.п. меньше. Цена
// выключения: города этих фракций примерно на 3/4 возвращаются к прежнему виду
// (городов без БК ~40% вместо 15%, у людей 46%).
//
// Решение владельца 28.10: пока оставить C1 и C2 включенными и выключить, если в
// живых матчах орки или демоны золото+ окажутся заметно слабее против людей.
// Выключить — false у подчасти фракции; C1 и C2 выключаются порознь. Вместе с
// записью поправить только тест решения «сейчас C1 и C2 действуют у всех» в
// utils/bots/evaluation/cityGrowth.test.js. Оба false у фракции — ровно плечо
// noc12 фокус-серий (проверено побайтно на сидах smoke_noc12_orcs и
// smoke_noc12_demons). C3–C5 и рынок политик рубильник не трогает. Харнесс
// выключенную подчасть фракции обратно не включит (legacy-наборы A/B только
// выключают): для нового замера вернуть true локально. Другие фракции играют с
// C1 и C2 и сюда без своей серии не вписываются: в среднем им C1+C2 помогают
// (r1_mix: +3.1 п.п., Вентори без них теряла бы 24 очка)
export const W36_FACTION_CITY_GROWTH_SWITCHES = {
  [FACTIONS.ORCS]: {ringReserve: true, quarterGrowth: true},
  [FACTIONS.DEMONS]: {ringReserve: true, quarterGrowth: true},
};

/**
 * Действует ли у ботов золото+ фракции подчасть из W36_FACTION_SWITCHABLE_PARTS:
 * фракции и подчасти вне рубильника — да
 */
export const checkIfW36FactionCityGrowthPartOn = (factionId, part) => (
  W36_FACTION_CITY_GROWTH_SWITCHES[factionId]?.[part] !== false
);

// --- Калибровка харнесса: ручки через globalThis (в проде не заданы)

// Имена глобалов-переопределений, которые читает getW36CityGrowthKnobs, — для
// проверки ручек харнесса (SIM_W36_KNOBS в server/scripts/simulateBotBatch.js:
// имя вне списка — ошибка, а не молча действующий дефолт). Новая ручка — сюда же
export const W36_CITY_GROWTH_KNOB_GLOBALS = [
  '__w36CityBaseQuartersTarget',
  '__w36RingReserveFactor',
  '__w36QuarterGrowthBase',
  '__w36QuarterGrowthSpecialShare',
  '__w36CityBarracksCap',
  '__w36DensityLostSlotPenalty',
  '__w36DensitySmallCityPenalty',
];

const readKnob = (overrideName, value) => {
  const override = globalThis[overrideName];
  return typeof override === 'number' && Number.isFinite(override) ? override : value;
};

/**
 * Ручки участка на один план стройки. Оверрайды харнесса —
 * globalThis.__w36RingReserveFactor, __w36QuarterGrowthBase,
 * __w36QuarterGrowthSpecialShare, __w36CityBarracksCap,
 * __w36DensityLostSlotPenalty, __w36DensitySmallCityPenalty,
 * __w36CityBaseQuartersTarget
 */
export const getW36CityGrowthKnobs = () => ({
  cityBaseQuartersTarget: readKnob('__w36CityBaseQuartersTarget', W36_CITY_BASE_QUARTERS_TARGET),
  hubBaseQuartersTarget: Math.max(
    readKnob('__w36CityBaseQuartersTarget', W36_CITY_BASE_QUARTERS_TARGET),
    W36_HUB_BASE_QUARTERS_TARGET
  ),
  ringReserveFactor: readKnob('__w36RingReserveFactor', W36_RING_RESERVE_FACTOR),
  quarterGrowthBase: readKnob('__w36QuarterGrowthBase', W36_QUARTER_GROWTH_BASE),
  quarterGrowthSpecialShare: readKnob('__w36QuarterGrowthSpecialShare', W36_QUARTER_GROWTH_SPECIAL_SHARE),
  cityBarracksCap: readKnob('__w36CityBarracksCap', W36_CITY_BARRACKS_CAP),
  densityLostSlotPenalty: readKnob('__w36DensityLostSlotPenalty', W36_DENSITY_LOST_SLOT_PENALTY),
  densitySmallCityPenalty: readKnob('__w36DensitySmallCityPenalty', W36_DENSITY_SMALL_CITY_PENALTY),
});
